export default __webpack_public_path__ + "static/media/love-you-mom.7e6737d2.png";